import IframeActivity from "./IframeActivity";

export default function FieldOfficer() {
    return (
        <IframeActivity
            src="/activities/field-officer/index.html"
            title="Field Officer"
        />
    );
}